<template>
    <div class="pageClass VideoList">
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        
        <!-- mobile/tablet -->
        <div class="d-flex flex-column listBtn" data-toggle="modal" data-target="#ModalList" v-if="ShowModalList" @click="SetProgessModal()">
            <font-awesome-icon icon="fa-solid fa-table-list" size="3x"/>
            <span class="mx-auto">影片清單</span>
        </div>
        
        <div v-show="!ShowModalList">
            <!--<div class="List"  >-->
            <div class="List" id="List" style="" >
                <div v-for="(CourseMaterialItem,CMIndex) in CourseMaterial">
                    <h6 class="MaterialCode pl-2">{{CourseMaterialItem.Name}}</h6>
                    <div v-for="(MaterialItem,Mindex) in CourseMaterialItem.Material" class="UnitProgess" >
                        <div v-for="(Videoitem,index) in MaterialItem.Video" > 
                            <div class="ListNameLine d-flex justify-content-start"  @click="changeVideo(Videoitem,MaterialItem.MaterialUnitId)">  
                                <font-awesome-icon icon="fa-solid fa-play" v-show="Videoitem.playing" />
                                <span class="UnitName flex-grow-1 ml-1">{{Mindex+1}}. {{Videoitem.Name}}</span>
                                <font-awesome-icon icon="fa-circle-play"  />
                                <span class="TotalTime mx-1">{{Math.trunc(Videoitem.VideoTime/60)}}分鐘</span>
                            </div>
                            <div class="ProgressLine d-flex " id="ProgressLine" ref="ProgressLine" :key="testOptions.layout.width" >
                                <progress-bar class="flex-grow-1" id="ProgressBar" :options="testOptions" :value="ProgessCalculate(Videoitem)"/>
                                <span class="progessNum mr-3">{{ProgessCalculate(Videoitem)}}%</span>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="ModalList" tabindex="-1" role="dialog" aria-labelledby="ModalListTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="ModalListTitle">影片清單</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="">
                            <div v-for="CourseMaterialItem in CourseMaterial">
                                <h6 class="MaterialCode">{{CourseMaterialItem.Name}}</h6>
                                <div v-for="(MaterialItem,index) in CourseMaterialItem.Material" class="UnitProgess">
                                    <div v-for="Videoitem in MaterialItem.Video">
                                        <div class="ListNameLine d-flex justify-content-start"  @click="changeVideo(Videoitem, MaterialItem.MaterialUnitId)" data-dismiss="modal" aria-label="Close">
                                            <font-awesome-icon icon="fa-solid fa-play" v-if="Videoitem.playing"/>
                                            <span class="UnitName flex-grow-1 ">{{index+1}}. {{Videoitem.Name}}</span>
                                            <font-awesome-icon icon="fa-circle-play"  />
                                            <span class="TotalTime mx-1">{{Math.trunc(Videoitem.VideoTime/60)}}分鐘</span>
                                        </div>
                                        <div class="ProgressLine d-flex " id="ProgressLineModal" ref="ProgressLineModal" :key="testOptions.layout.width" >
                                            <progress-bar class="flex-grow-1" id="ProgressBar" :options="testOptions" :value="ProgessCalculate(Videoitem)"/>
                                            <span class="progessNum mr-2">{{ProgessCalculate(Videoitem)}}%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'



export default {
    name: 'VideoList',
    props: ['CourseMaterial'],
    components:{
    },
    data () {
        return {
            showLoading:false,
            showVideoList:true,
            ShowModalList:false,
            testOptions: {
                text: {
                    // color: '#FFFFFF',
                    // shadowEnable: true,
                    // shadowColor: '#000000',
                    // fontSize: 10,
                    // fontFamily: 'Helvetica',
                    // dynamicPosition: false,
                    hideText: true,
                },
                progress: {
                    color: '#99d9be',
                    backgroundColor: '#797979',
                    inverted: false
                },
                layout: {
                    height: 8,
                    width: 180,
                    verticalTextAlign: 61,
                    horizontalTextAlign: 43,
                    zeroOffset: 0,
                    strokeWidth: 30,
                    progressPadding: 0,
                    type: 'line'
                }
            }
        }
    },
    mounted(){
        window.addEventListener('resize', this.SetProgessModal);
        this.$nextTick(() => { 
            setTimeout(() => {
                this.SetProgessModal()
            }, 1000)
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.SetProgessModal);
    },
    methods:{
        SetProgessModal(){
            if(this.ShowModalList){ // mobile/tablet
                if(this.$refs.ProgressLineModal != undefined){
                    if(this.$refs.ProgressLineModal.length > 0){
                        this.testOptions.layout.width = parseInt(this.$refs.ProgressLineModal[0].clientWidth - 60)
                    }
                }else{
                    setTimeout(() => {
                        this.SetProgessModal();
                    }, 500)
                }
            }else{ //computer
                if(this.$refs.ProgressLine != undefined){
                    if(this.$refs.ProgressLine.length > 0){
                        this.testOptions.layout.width = parseInt(this.$refs.ProgressLine[0].clientWidth - 60)
                    }
                }else{
                    setTimeout(() => {
                        this.SetProgessModal();
                    }, 500)
                }
            }
        },
        changeVideo(Videoitem,MaterialUnitId){
            this.$root.$refs.VideoClassPage.SetChangVideoItem(Videoitem,'changeVideo',MaterialUnitId);
        },
        deviceType(){
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                this.ShowModalList = true;
                // return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                this.ShowModalList = true;
                // return "mobile";
            }else{
                this.ShowModalList = false;
            }
        },
        ProgessCalculate(item){
            if(item.LastendTime >0){
                return Math.round((item.LastendTime/item.VideoTime)*100,0)
            }else{
                return 0
            }
        },
    },    
    created(){
        this.deviceType();
        
    }
}
</script>





// WEBPACK FOOTER //
// src/components/VideoPage/VideoList.vue